import { Outlet, useMatch } from 'react-router-dom';

import Page from 'components/Page';
import WithDataHeader from 'components/WithDataHeader';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

const DataPage: FunctionComponent<Props> = ({ className = '', testId = TEST_ID }) => {
    const isDataRoute = useMatch('/data/:section?');

    return (
        <Page className={className} testId={testId}>
            <WithDataHeader>{isDataRoute ? <Outlet /> : <div />}</WithDataHeader>
        </Page>
    );
};

export default DataPage;
